(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["no925-browse-memory"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('no925-browse-memory')) {
    customElements.define('no925-browse-memory',class extends HTMLElement {
      connectedCallback() {
        this.controller=new AbortController();
        this.restoring=false;
        const options={signal:this.controller.signal};
        this.key=()=>{
          const params=new URLSearchParams(location.search);
          params.delete('preview_theme_id');params.delete('section_id');params.sort();
          return 'no925:browse:'+window.Shopify?.theme?.id+':'+location.pathname+'?'+params.toString();
        };
        this.save=()=>{
          if(this.restoring)return;
          const pager=document.querySelector('no925-infinite-products');
          const colors=[...document.querySelectorAll('.no925-tee__item[data-preview-variant]')].map(e=>[e.dataset.productId,e.dataset.previewVariant]);
          try{sessionStorage.setItem(this.key(),JSON.stringify({time:Date.now(),y:scrollY,pages:pager?.pages||1,colors}));}catch{}
        };
        window.addEventListener('pagehide',this.save,options);
        document.addEventListener('click',e=>{if(e.target.closest('a[href*="/products/"]'))this.save();},options);
        const navigation=performance.getEntriesByType('navigation')[0];
        if(navigation?.type==='back_forward')this.restore();
      }
      disconnectedCallback(){this.controller?.abort();}
      async restore() {
        let state;
        try{state=JSON.parse(sessionStorage.getItem(this.key()));}catch{return;}
        if(!state||Date.now()-state.time>7200000)return;
        this.restoring=true;
        const current=location.href;
        let cancelled=false;
        const stop=()=>{cancelled=true;};
        const controller=new AbortController();
        ['wheel','touchstart','keydown'].forEach(type=>window.addEventListener(type,stop,{once:true,passive:true,signal:controller.signal}));
        try {
          await customElements.whenDefined('no925-infinite-products');
          await new Promise(resolve=>requestAnimationFrame(resolve));
          const pager=document.querySelector('no925-infinite-products');
          if(pager)pager.observer?.disconnect();
          while(pager&&pager.pages<Math.min(state.pages,50)&&pager.dataset.next&&!cancelled&&location.href===current){
            if(!await pager.load({restore:true}))break;
          }
          if(cancelled||location.href!==current)return;
          for(const [product,variant] of state.colors||[]){
            document.querySelector('.no925-tee__item[data-product-id="'+product+'"] no925-card-colors [data-variant="'+variant+'"]')?.click();
          }
          await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
          window.scrollTo({top:state.y,behavior:'instant'});
          if(pager)pager.autoBatches=Math.min(2,pager.pages-1);
        } finally {this.restoring=false;controller.abort();}
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["no925-card-colors"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('no925-card-colors')) {
    customElements.define('no925-card-colors',class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound=true;
        this.addEventListener('click',event=>{
          const button=event.target.closest('[data-color]');
          if (!button || button.disabled) return;
          const card=this.closest('.no925-tee__item');
          const image=card.querySelector('.no925-tee__image');
          image.removeAttribute('srcset');
          image.src=button.dataset.image;
          image.alt=card.querySelector('h3').textContent+' - '+button.dataset.color;
          card.querySelector('.no925-tee__product').href=button.dataset.url;
          card.querySelector('.no925-tee__price').textContent=button.dataset.price;
          this.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
          this.querySelector('.no925-card-colors__name').textContent=button.dataset.color;
          const quick=card.querySelector('no925-tee-quick-add');
          const group=quick?.querySelector('[data-option-index="'+this.dataset.optionIndex+'"]');
          const input=[...(group?.querySelectorAll('input')||[])].find(i=>i.value===button.dataset.color);
          if (input) { input.checked=true; input.dispatchEvent(new Event('change',{bubbles:true})); }
          card.dataset.previewVariant=button.dataset.variant;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["no925-filter-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('no925-filter-guide')) {
    customElements.define('no925-filter-guide', class extends HTMLElement {
      connectedCallback() {
        this.aside = this.closest('aside');
        if (!this.aside) return;
        this.navigation = this.querySelector('.no925-shop-nav');
        this.mobileMedia = matchMedia('(max-width:749px)');
        this.placeNavigation = () => {
          this.observer?.disconnect();
          const target = this.mobileMedia.matches ? this.aside.querySelector('#FacetsWrapperMobile') : this;
          if (target && this.navigation.parentElement !== target) {
            this.navigation.open = !this.mobileMedia.matches;
            target.prepend(this.navigation);
          }
          this.observer?.observe(this.aside, { childList:true, subtree:true });
        };
        this.navigation.addEventListener('click', event => {
          if (this.mobileMedia.matches && event.target.closest('summary')) event.stopImmediatePropagation();
        }, true);
        this.navigation.addEventListener('keyup', event => {
          if (this.mobileMedia.matches && event.key === 'Escape') {
            event.stopPropagation();
            const drawer = this.aside.querySelector('menu-drawer');
            drawer.closeMenuDrawer(event, drawer.querySelector('summary'));
          }
        });
        this.mobileMedia.addEventListener('change', this.placeNavigation);
        this.drawerDetails = this.aside.querySelector('.mobile-facets__disclosure');
        this.returnFocus = () => {
          if (!this.drawerDetails.open) {
            const trigger = this.drawerDetails.querySelector('summary');
            trigger.setAttribute('aria-expanded', 'false');
            if (this.mobileMedia.matches) trigger.focus({ preventScroll:true });
          }
        };
        this.drawerDetails?.addEventListener('toggle', this.returnFocus);
        this.enhance = this.enhance.bind(this);
        this.observer = new MutationObserver(this.enhance);
        this.placeNavigation();
        this.enhance();
      }
      disconnectedCallback() { this.observer?.disconnect(); this.mobileMedia?.removeEventListener('change', this.placeNavigation); this.drawerDetails?.removeEventListener('toggle', this.returnFocus); }
      enhance() {
        this.observer.disconnect();
        const mobileForm=this.aside.querySelector('#FacetFiltersFormMobile');
        const activeValues=[...(mobileForm?.querySelectorAll('input[type="checkbox"]:checked')||[])].length;
        const hasPrice=[...(mobileForm?.querySelectorAll('price-range input')||[])].some(input=>input.value!=='');
        const activeCount=activeValues+(hasPrice?1:0);
        const opener=this.aside.querySelector('.mobile-facets__open');
        let badge=opener?.querySelector('.no925-active-count');
        if(opener&&!badge){badge=document.createElement('span');badge.className='no925-active-count';opener.append(badge);}
        if(badge){
          const label=this.dataset.activeLabel.replace('__COUNT__',String(activeCount));
          badge.hidden=activeCount===0;
          badge.setAttribute('aria-label',label);
          if(badge.textContent!==String(activeCount))badge.textContent=String(activeCount);
        }
        const heading = this.aside.querySelector('#verticalTitle');
        if (heading && heading.textContent.trim() !== this.dataset.refine) heading.textContent = this.dataset.refine;
        this.aside.querySelectorAll('.js-filter').forEach(group => {
          const input = group.querySelector('input[name]');
          if (!input) return;
          const name = input.name;
          group.dataset.no925Kind = name.includes('.price.') ? 'price' : name.split('.').pop();
          if (name.includes('product_type') && group.querySelectorAll('input[type=checkbox]').length < 2 && !group.querySelector('input:checked')) group.hidden = true;
          else group.hidden = false;
          if (!group.id.includes('Mobile') && !group.dataset.no925Opened) {
            group.open = name.includes('.price.') || !!group.querySelector('input:checked');
            group.dataset.no925Opened = 'true';
          }
          const list = group.querySelector('ul');
          if (list && list.children.length > 8 && !list.dataset.no925Search) {
            list.dataset.no925Search = 'true';
            group.querySelectorAll('.no925-option-search, .no925-option-empty').forEach(element => element.remove());
            group.querySelector('show-more-button')?.setAttribute('hidden', '');
            list.classList.add('no925-searchable-list');
            const label = document.createElement('label');
            label.className = 'no925-option-search';
            label.textContent = this.dataset.search;
            const search = document.createElement('input');
            search.type = 'search';
            search.autocomplete = 'off';
            label.append(search);
            list.before(label);
            const empty = document.createElement('p');
            empty.className = 'no925-filter-note no925-option-empty';
            empty.textContent = this.dataset.empty;
            empty.hidden = true;
            empty.setAttribute('role', 'status');
            list.after(empty);
            search.addEventListener('input', event => {
              event.stopPropagation();
              const term = search.value.trim().toLowerCase();
              let visible = 0;
              [...list.children].forEach(item => {
                const match = item.textContent.toLowerCase().includes(term);
                item.toggleAttribute('data-search-hidden', !match);
                if (match) visible++;
              });
              empty.hidden = visible > 0;
            });
            search.addEventListener('keydown', event => { if (event.key === 'Enter') event.preventDefault(); });
          }
          const range = group.querySelector('price-range');
          const template = this.querySelector('.no925-price-template');
          if (range && template && !group.querySelector('.no925-price-bands')) {
            const min = range.querySelector('input[name$="gte"]');
            const max = range.querySelector('input[name$="lte"]');
            if (!min || !max) return;
            const bands = template.content.firstElementChild.cloneNode(true);
            const details = document.createElement('details');
            details.className = 'no925-custom-price';
            const summary = document.createElement('summary');
            summary.textContent = this.dataset.custom;
            details.append(summary);
            range.before(bands, details);
            details.append(range);
            group.querySelector('.facets__header-vertical, .mobile-facets__info')?.setAttribute('hidden', '');
            let selected = false;
            const samePrice = (value, expected) => expected === '' ? value === '' : value !== '' && Number(value) === Number(expected);
            bands.querySelectorAll('button').forEach(button => {
              const active = samePrice(min.value, button.dataset.min) && samePrice(max.value, button.dataset.max);
              button.setAttribute('aria-pressed', String(active));
              selected ||= active;
              button.addEventListener('click', () => {
                min.value = button.dataset.min;
                max.value = button.dataset.max;
                range.setMinAndMaxValues?.();
                bands.querySelectorAll('button').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
                min.dispatchEvent(new Event('input', { bubbles:true }));
              });
            });
            details.open = !selected;
            range.addEventListener('input', () => {
              bands.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(samePrice(min.value, button.dataset.min) && samePrice(max.value, button.dataset.max))));
            });
          }
        });
        const mobile = this.aside.querySelector('#FacetsWrapperMobile');
        const mobileSort = mobile?.querySelector('[id^="Details-Mobile-SortBy"]');
        if (mobileSort && mobile.firstElementChild !== mobileSort) mobile.prepend(mobileSort);
        const desktop = this.aside.querySelector('#FacetsWrapperDesktop');
        if (desktop) {
          const priority = ['product_type', 'color', 'size', 'price', 'availability'];
          const groups = [...desktop.querySelectorAll(':scope > .js-filter')];
          const sorted = [...groups].sort((a, b) => priority.indexOf(a.dataset.no925Kind) - priority.indexOf(b.dataset.no925Kind));
          if (sorted.some((group, index) => group !== groups[index])) sorted.forEach(group => desktop.append(group));
        }
        this.observer.observe(this.aside, { childList:true, subtree:true });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["no925-premium-commerce"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nfr-commerce')) {
  customElements.define('nfr-commerce', class extends HTMLElement {
    connectedCallback() {
      this.root = document.querySelector('product-info');
      if (!this.root) return;
      this.dialog = this.querySelector('.nfr-size-drawer');
      this.imageDialog = this.querySelector('.nfr-image-dialog');
      this.querySelector('.nfr-image-close').addEventListener('click', () => this.imageDialog.close());
      this.imageDialog.addEventListener('close', () => this.imageTrigger?.focus());
      this.closeButton = this.querySelector('.nfr-drawer-close');
      this.closeButton.addEventListener('click', () => this.closeDrawer());
      this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.closeDrawer(); });
      this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog && event.clientX < this.dialog.getBoundingClientRect().left) this.closeDrawer(); });
      this.dialog.addEventListener('close', () => { clearTimeout(this.closeTimer); this.dialog.classList.remove('is-closing'); this.trigger?.focus(); });
      this.clickHandler = (event) => {
        const imageTrigger = event.target.closest('.product__media-toggle');
        if (imageTrigger) {
          event.preventDefault(); event.stopImmediatePropagation();
          const source = imageTrigger.closest('.product__media-item')?.querySelector('.product__media img');
          if (!source) return;
          this.imageTrigger = imageTrigger;
          const image = this.imageDialog.querySelector('img');
          image.src = source.src;
          image.alt = source.alt;
          this.imageDialog.showModal();
          this.querySelector('.nfr-image-close').focus();
          return;
        }
        const trigger = event.target.closest('.nfr-guide-trigger');
        if (!trigger) return;
        this.trigger = trigger;
        this.dialog.classList.remove('is-closing');
        this.dialog.showModal();
        this.closeButton.focus();
      };
      this.root.addEventListener('click', this.clickHandler, true);
      this.enhance();
      this.observer = new MutationObserver(() => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.enhance());
      });
      this.observer.observe(this.root, {childList:true,subtree:true});
    }
    closeDrawer() {
      if (!this.dialog.open || this.dialog.classList.contains('is-closing')) return;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) { this.dialog.close(); return; }
      this.dialog.classList.add('is-closing');
      this.closeTimer = setTimeout(() => this.dialog.close(), 230);
    }
    enhance() {
      const fields = this.root.querySelectorAll('variant-selects fieldset');
      fields.forEach((field) => {
        const legend = field.querySelector('legend');
        if (!legend) return;
        const radios = [...field.querySelectorAll('input[type=radio]')];
        if (radios.some((radio) => radio.value === 'Tan')) {
          field.classList.add('nfr-color');
          let name = legend.querySelector('.nfr-color-name');
          if (!name) { name = document.createElement('span'); name.className = 'nfr-color-name'; legend.append(name); }
          const selected = radios.find((radio) => radio.checked)?.value || '';
          if (name.textContent !== selected) name.textContent = selected;
          const colorSlug = selected.toLowerCase().replaceAll(' ', '-');
          const seenViews = new Set();
          this.root.querySelectorAll('.thumbnail-list__item').forEach((item) => {
            const src = item.querySelector('img')?.getAttribute('src') || '';
            const matched = src.match(new RegExp('t-shirt-' + colorSlug + '-(front|back|left|right)-'));
            const visible = Boolean(matched && !seenViews.has(matched[1]));
            if (matched && visible) seenViews.add(matched[1]);
            if (matched) {
              const view = this.dataset[matched[1]];
              item.dataset.viewLabel = view;
              let label = item.querySelector('.nfr-view-label');
              if (!label) { label = document.createElement('span'); label.className = 'nfr-view-label'; label.setAttribute('aria-hidden','true'); item.append(label); }
              if (label.textContent !== view) label.textContent = view;
            }
            item.classList.toggle('nfr-view-hidden', !visible);
            const media = this.root.querySelector('[data-media-id="' + item.dataset.target + '"]');
            if (media) media.classList.toggle('nfr-view-hidden', !visible);
          });
          radios.forEach((radio) => { const label = field.querySelector('label[for="' + radio.id + '"]'); if (label) label.title = radio.value; });
        }
        if (radios.some((radio) => radio.value === 'XS')) {
          field.classList.add('nfr-size');
          if (!legend.querySelector('.nfr-guide-trigger')) {
            const trigger = document.createElement('button');
            trigger.type = 'button'; trigger.className = 'nfr-guide-trigger';
            trigger.textContent = this.dataset.guideLabel; trigger.setAttribute('aria-haspopup','dialog');
            legend.append(trigger);
          }
        }
      });
      const buttons = this.root.querySelector('.product-form__buttons');
      const quantity = this.root.querySelector('.product-form__quantity');
      if (buttons && quantity && quantity.parentElement !== buttons) buttons.prepend(quantity);
      const installment = this.root.querySelector('.installment')?.parentElement;
      const details = this.root.querySelector('.nfr-buy-details');
      if (installment && details && installment.nextElementSibling !== details) details.before(installment);
      this.root.classList.add('nfr-enhanced');
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.frame);
      this.root?.removeEventListener('click', this.clickHandler, true);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["no925-priority-commerce"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vg-commerce')) {
  customElements.define('vg-commerce', class extends HTMLElement {
    connectedCallback() {
      this.root = document.querySelector('product-info');
      if (!this.root) return;
      this.dialog = this.querySelector('.nfr-size-drawer');
      this.imageDialog = this.querySelector('.nfr-image-dialog');
      this.querySelector('.nfr-image-close').addEventListener('click', () => this.imageDialog.close());
      this.imageDialog.addEventListener('close', () => this.imageTrigger?.focus());
      this.closeButton = this.querySelector('.nfr-drawer-close');
      this.closeButton.addEventListener('click', () => this.closeDrawer());
      this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.closeDrawer(); });
      this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog && event.clientX < this.dialog.getBoundingClientRect().left) this.closeDrawer(); });
      this.dialog.addEventListener('close', () => { clearTimeout(this.closeTimer); this.dialog.classList.remove('is-closing'); this.trigger?.focus(); });
      this.clickHandler = (event) => {
        const imageTrigger = event.target.closest('.product__media-toggle');
        if (imageTrigger) {
          event.preventDefault(); event.stopImmediatePropagation();
          const source = imageTrigger.closest('.product__media-item')?.querySelector('.product__media img');
          if (!source) return;
          this.imageTrigger = imageTrigger;
          const image = this.imageDialog.querySelector('img');
          image.src = source.src;
          image.alt = source.alt;
          this.imageDialog.showModal();
          this.querySelector('.nfr-image-close').focus();
          return;
        }
        const trigger = event.target.closest('.nfr-guide-trigger');
        if (!trigger) return;
        event.preventDefault();
        this.trigger = trigger;
        this.dialog.classList.remove('is-closing');
        this.dialog.showModal();
        this.closeButton.focus();
      };
      document.addEventListener('click', this.clickHandler, true);
      this.enhance();
      this.observer = new MutationObserver(() => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.enhance());
      });
      this.observer.observe(this.root, {childList:true,subtree:true});
    }
    closeDrawer() {
      if (!this.dialog.open || this.dialog.classList.contains('is-closing')) return;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) { this.dialog.close(); return; }
      this.dialog.classList.add('is-closing');
      this.closeTimer = setTimeout(() => this.dialog.close(), 230);
    }
    enhance() {
      const fields = this.root.querySelectorAll('variant-selects fieldset');
      fields.forEach((field) => {
        const legend = field.querySelector('legend');
        if (!legend) return;
        const radios = [...field.querySelectorAll('input[type=radio]')];
        if (radios.some((radio) => ['Tan','Black','White','Vintage Black','Dust','Asphalt','Military Green','Adobe','Bone','Oatmeal Heather','Navy','Spruce','Khaki','Dark Navy','Dark Grey','Multicam Black','Dark Olive','Camel'].includes(radio.value))) {
          field.classList.add('nfr-color');
          let name = legend.querySelector('.nfr-color-name');
          if (!name) { name = document.createElement('span'); name.className = 'nfr-color-name'; legend.append(name); }
          const selected = radios.find((radio) => radio.checked)?.value || '';
          if (name.textContent !== selected) name.textContent = selected;
          const colorSlug = selected.toLowerCase().replaceAll(' ', '-');
          const seenViews = new Set();
          this.root.querySelectorAll('.thumbnail-list__item').forEach((item) => {
            const src = item.querySelector('img')?.getAttribute('src') || '';
            const matched = src.match(new RegExp('(?:t-shirt|hoodie)-' + colorSlug + '-(front|back|left|right)-'));
            const visible = Boolean(matched && !seenViews.has(matched[1]));
            if (matched && visible) seenViews.add(matched[1]);
            if (matched) {
              const view = this.dataset[matched[1]];
              item.dataset.viewLabel = view;
              let label = item.querySelector('.nfr-view-label');
              if (!label) { label = document.createElement('span'); label.className = 'nfr-view-label'; label.setAttribute('aria-hidden','true'); item.append(label); }
              if (label.textContent !== view) label.textContent = view;
            }
            item.classList.toggle('nfr-view-hidden', Boolean(matched) && !visible);
            const media = this.root.querySelector('[data-media-id="' + item.dataset.target + '"]');
            if (media) media.classList.toggle('nfr-view-hidden', Boolean(matched) && !visible);
          });
          radios.forEach((radio) => { const label = field.querySelector('label[for="' + radio.id + '"]'); if (label) label.title = radio.value; });
        }
        if (radios.some((radio) => ['XS','S','M','L','XL'].includes(radio.value))) {
          field.classList.add('nfr-size');
          if (!legend.querySelector('.nfr-guide-trigger')) {
            const trigger = document.createElement('button');
            trigger.type = 'button'; trigger.className = 'nfr-guide-trigger';
            trigger.textContent = this.dataset.guideLabel; trigger.setAttribute('aria-haspopup','dialog');
            legend.append(trigger);
          }
        }
      });
      if (!this.root.querySelector('.nfr-size')) { const guide=this.root.querySelector('details.no925-size-guide'); if(guide && !guide.previousElementSibling?.classList.contains('nfr-guide-trigger')) { const button=document.createElement('button');button.type='button';button.className='nfr-guide-trigger';button.textContent=this.dataset.guideLabel;button.setAttribute('aria-haspopup','dialog');guide.before(button); } }
      const buttons = this.root.querySelector('.product-form__buttons');
      const quantity = this.root.querySelector('.product-form__quantity');
      if (buttons && quantity && quantity.parentElement !== buttons) buttons.prepend(quantity);
      const installment = this.root.querySelector('.installment')?.parentElement;
      const details = this.root.querySelector('.nfr-buy-details');
      if (installment && details && installment.nextElementSibling !== details) details.before(installment);
      this.root.classList.add('nfr-enhanced');
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.frame);
      this.root?.removeEventListener('click', this.clickHandler, true);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["no925-vg-commerce"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vg-commerce')) {
  customElements.define('vg-commerce', class extends HTMLElement {
    connectedCallback() {
      this.root = document.querySelector('product-info');
      if (!this.root) return;
      this.dialog = this.querySelector('.nfr-size-drawer');
      this.imageDialog = this.querySelector('.nfr-image-dialog');
      this.querySelector('.nfr-image-close').addEventListener('click', () => this.imageDialog.close());
      this.imageDialog.addEventListener('close', () => this.imageTrigger?.focus());
      this.closeButton = this.querySelector('.nfr-drawer-close');
      this.closeButton.addEventListener('click', () => this.closeDrawer());
      this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.closeDrawer(); });
      this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog && event.clientX < this.dialog.getBoundingClientRect().left) this.closeDrawer(); });
      this.dialog.addEventListener('close', () => { clearTimeout(this.closeTimer); this.dialog.classList.remove('is-closing'); this.trigger?.focus(); });
      this.clickHandler = (event) => {
        const imageTrigger = event.target.closest('.product__media-toggle');
        if (imageTrigger) {
          event.preventDefault(); event.stopImmediatePropagation();
          const source = imageTrigger.closest('.product__media-item')?.querySelector('.product__media img');
          if (!source) return;
          this.imageTrigger = imageTrigger;
          const image = this.imageDialog.querySelector('img');
          image.src = source.src;
          image.alt = source.alt;
          this.imageDialog.showModal();
          this.querySelector('.nfr-image-close').focus();
          return;
        }
        const trigger = event.target.closest('.nfr-guide-trigger');
        if (!trigger) return;
        this.trigger = trigger;
        this.dialog.classList.remove('is-closing');
        this.dialog.showModal();
        this.closeButton.focus();
      };
      this.root.addEventListener('click', this.clickHandler, true);
      this.enhance();
      this.observer = new MutationObserver(() => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.enhance());
      });
      this.observer.observe(this.root, {childList:true,subtree:true});
    }
    closeDrawer() {
      if (!this.dialog.open || this.dialog.classList.contains('is-closing')) return;
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) { this.dialog.close(); return; }
      this.dialog.classList.add('is-closing');
      this.closeTimer = setTimeout(() => this.dialog.close(), 230);
    }
    enhance() {
      const fields = this.root.querySelectorAll('variant-selects fieldset');
      fields.forEach((field) => {
        const legend = field.querySelector('legend');
        if (!legend) return;
        const radios = [...field.querySelectorAll('input[type=radio]')];
        if (radios.some((radio) => ['Tan','Black','White'].includes(radio.value))) {
          field.classList.add('nfr-color');
          let name = legend.querySelector('.nfr-color-name');
          if (!name) { name = document.createElement('span'); name.className = 'nfr-color-name'; legend.append(name); }
          const selected = radios.find((radio) => radio.checked)?.value || '';
          if (name.textContent !== selected) name.textContent = selected;
          const colorSlug = selected.toLowerCase().replaceAll(' ', '-');
          const seenViews = new Set();
          this.root.querySelectorAll('.thumbnail-list__item').forEach((item) => {
            const src = item.querySelector('img')?.getAttribute('src') || '';
            const matched = src.match(new RegExp('(?:t-shirt|hoodie)-' + colorSlug + '-(front|back|left|right)-'));
            const visible = Boolean(matched && !seenViews.has(matched[1]));
            if (matched && visible) seenViews.add(matched[1]);
            if (matched) {
              const view = this.dataset[matched[1]];
              item.dataset.viewLabel = view;
              let label = item.querySelector('.nfr-view-label');
              if (!label) { label = document.createElement('span'); label.className = 'nfr-view-label'; label.setAttribute('aria-hidden','true'); item.append(label); }
              if (label.textContent !== view) label.textContent = view;
            }
            item.classList.toggle('nfr-view-hidden', !visible);
            const media = this.root.querySelector('[data-media-id="' + item.dataset.target + '"]');
            if (media) media.classList.toggle('nfr-view-hidden', !visible);
          });
          radios.forEach((radio) => { const label = field.querySelector('label[for="' + radio.id + '"]'); if (label) label.title = radio.value; });
        }
        if (radios.some((radio) => ['XS','S','M','L','XL'].includes(radio.value))) {
          field.classList.add('nfr-size');
          if (!legend.querySelector('.nfr-guide-trigger')) {
            const trigger = document.createElement('button');
            trigger.type = 'button'; trigger.className = 'nfr-guide-trigger';
            trigger.textContent = this.dataset.guideLabel; trigger.setAttribute('aria-haspopup','dialog');
            legend.append(trigger);
          }
        }
      });
      const buttons = this.root.querySelector('.product-form__buttons');
      const quantity = this.root.querySelector('.product-form__quantity');
      if (buttons && quantity && quantity.parentElement !== buttons) buttons.prepend(quantity);
      const installment = this.root.querySelector('.installment')?.parentElement;
      const details = this.root.querySelector('.nfr-buy-details');
      if (installment && details && installment.nextElementSibling !== details) details.before(installment);
      this.root.classList.add('nfr-enhanced');
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      clearTimeout(this.closeTimer);
      cancelAnimationFrame(this.frame);
      this.root?.removeEventListener('click', this.clickHandler, true);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
